import { render, staticRenderFns } from "./lp-collections-3.vue?vue&type=template&id=366ac53c&scoped=true"
import script from "./lp-collections-3.vue?vue&type=script&lang=js"
export * from "./lp-collections-3.vue?vue&type=script&lang=js"
import style0 from "./lp-collections-3.vue?vue&type=style&index=0&id=366ac53c&prod&scoped=true&lang=css"
import style1 from "./lp-collections-3.vue?vue&type=style&index=1&id=366ac53c&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366ac53c",
  null
  
)

export default component.exports